import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadFileService {
  private baseUrl = environment.baseUrl+'/uploadFile';

  constructor(private http: HttpClient) { }
  
  uploadFile(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(this.baseUrl + '/upload', formData, { reportProgress: true, observe: 'events' });
  }
  getFileList(): Observable<string[]> {
    return this.http.get<string[]>(this.baseUrl);
  }
}
